import { render, staticRenderFns } from "./EntryWakeTip.vue?vue&type=template&id=b5be6590&scoped=true&"
import script from "./EntryWakeTip.vue?vue&type=script&lang=js&"
export * from "./EntryWakeTip.vue?vue&type=script&lang=js&"
import style0 from "./EntryWakeTip.vue?vue&type=style&index=0&id=b5be6590&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5be6590",
  null
  
)

export default component.exports